var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700012 4.02495V15.9875C0.700012 18.4375 3.36251 19.975 5.48751 18.75L10.675 15.7625L15.8625 12.7625C17.9875 11.5375 17.9875 8.47495 15.8625 7.24995L10.675 4.24995L5.48751 1.26245C3.36251 0.0374511 0.700012 1.56245 0.700012 4.02495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.0085dec5cb635e6a4b0b73a507947989.svg";
export { ForwardRef as ReactComponent };